import { HTTP_CP_SmartSearchDeal } from '@api-new/mortgageservice';
import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { smartSearchDealsAdapter } from '@shared/store/smart-search-deals/smart-search-deals.reducer';
import { SmartSearchDealsState } from '@shared/store/smart-search-deals/smart-search-deals.state';

const { selectEntities } = smartSearchDealsAdapter.getSelectors();
export const selectSmartSearchDealsState = createFeatureSelector<SmartSearchDealsState>('smartSearchDeals');
export const selectSmartSearchDealEntities = createSelector(selectSmartSearchDealsState, (smartSearchDealsState: SmartSearchDealsState) =>
  selectEntities(smartSearchDealsState),
);

export const selectSmartSearchDealsBySmartSearchId = (smartSearchId: string): MemoizedSelector<object, HTTP_CP_SmartSearchDeal[]> =>
  createSelector(
    selectSmartSearchDealEntities,
    (smartSearchDealEntities) => smartSearchDealEntities?.[smartSearchId]?.smartSearchDeals ?? [],
  );

export const selectIsLoadingSmartSearchDeals = createSelector(
  selectSmartSearchDealsState,
  (smartSearchDealsState: SmartSearchDealsState): boolean => smartSearchDealsState.loading,
);

export const selectSmartSearchDealBySmartSearchIdAndDealHash = (
  smartSearchId: string,
  dealHash: string,
): MemoizedSelector<object, HTTP_CP_SmartSearchDeal> =>
  createSelector(
    selectSmartSearchDealEntities,
    (smartSearchDealEntities) => smartSearchDealEntities?.[smartSearchId]?.smartSearchDeals?.find((d) => d.dealHash == dealHash) ?? null,
  );
